"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PinSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6.99908827,12.7061951 L4.83320852,14.860933 C4.64173194,15.0514246 4.33208557,15.0506261 4.14159399,14.8591495 C3.94940014,14.6645544 3.95006265,14.3534283 4.14182446,14.1609128 L6.29358665,12.0006934 L3.79289322,9.5 L4.51115041,8.7817428 C5.33863234,7.95426088 6.52491966,7.59508198 7.67243062,7.82458417 L8.33566264,7.95723058 C8.33566264,7.95723058 8.70731269,7.58558053 9.45061277,6.84228044 C9.18826283,5.83141464 9.47528859,4.97228695 10.0844643,4.36311127 L10.6617219,3.78585366 L15.2002047,8.50690213 L14.7275854,8.97952134 C14.0580047,9.64910207 13.0841923,9.89746628 12.1350454,9.5720614 C11.4068614,10.3002454 11.0427694,10.6643374 11.0427694,10.6643374 L11.1754158,11.3275694 C11.404918,12.4750803 11.0457391,13.6613677 10.2182572,14.4888496 L9.5,15.2071068 L6.99908827,12.7061951 Z M10.5493872,7.15771956 C9.29268731,8.41441947 8.66433736,9.04276942 8.66433736,9.04276942 L7.47631449,8.80516485 C6.6566638,8.64123471 5.79841693,8.90824945 5.20710678,9.5 C5.82473697,10.1135538 8.77113404,13.0590078 9.5,13.7928932 C10.0792635,13.2170377 10.3587653,12.3433362 10.1948352,11.5236855 L9.95723058,10.3356626 C9.95723058,10.3356626 10.5931386,9.69975463 11.8649546,8.4279386 C12.9389346,8.85225356 13.3989543,8.71536598 13.7771705,8.46956292 L10.6572703,5.22416114 C10.3904963,5.57566372 10.2182572,6.09981327 10.5493872,7.15771956 Z" })));
};
PinSmall.displayName = 'PinSmall';
exports.default = PinSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PinSmall.js.map